<label [class.clickable]="clickable">
  <ng-content></ng-content>
  <span *ngIf="hasRequiredBadge" class="badge-required">*</span>
</label>
<span *ngIf="description" class="description">
  {{ description }}
</span>
